import $ from 'jquery'
import Vue from "vue"
import Quiz from './quiz/quiz'
import { markupAddons } from './addons'
import { initMediaAsset } from './init_markup_asset_media'

export function initMarkup($container) {
  setupMarkupQuiz($container)
  markupAddons($container)
  addSharedFacts($container)
  smoothScroll($container)

  $('.markup-media-asset', $container).each(function() {
    initMediaAsset($(this))
  })
}

function setupMarkupQuiz($section) {
  const quizzes = []

  $section.find(".quiz").replaceWith(function() {
    const $quiz = $(this)

    const dataText = $quiz[0].firstChild.data
    const quizResponse = JSON.parse(dataText)
    const questions = quizResponse.questions
    quizzes.push(questions)
    return $("<div class='m-quiz' />")
  })

  quizzes.forEach(questions => {
    const el = $section.find('.m-quiz').get(0)

    new Vue({
      el,
      render(h) {
        return h(Quiz, {
          props: { questions }
        })
      }
    })
  })
}

function smoothScroll($container) {
  // to scroll inside current $container area
  $('#toc a[href^="#"]:not(.facts-link)', $container).on('click', function() {
    if ($('body').hasClass('tutorial-page')) {
      $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]', $container).offset().top - 70 //'70' is height of sticky edit panel
      }, 500);
    }
  })

  // additional facts scroll by all page
  $('#toc a[href^="#"].facts-link', $container).on('click', function() {
    if ($('body').hasClass('tutorial-page')) {
      $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top - 40 //'40' just paddind for correct view
      }, 500);
    }
  })
}

function addSharedFacts($container) {
  const $toc = $('#toc', $container)
  const $facts = $('.shared-facts-wrapper')

  if ($toc.length && $facts.length) {
    $('td' ,$toc).append('<ul class="shared-facts-additional-list"></ul>')

    $('.shared-facts-wrapper').each(function(index) {
      let sharedIcon = $('.box-header-icon i', $(this)).attr('class')
      let sharedText = $('.box-header-text', $(this)).text().trim()
      let sharedFactsId = 'shared_facts_'+index
      let hrefLink = '<a href="#'+sharedFactsId+'" class="facts-link"><i class="'+sharedIcon+'"></i>'+sharedText+'</a>'
      let anchor = '<a name="'+sharedFactsId+'"></a>'

      $('.box-header-text', $(this)).prepend(anchor)

      $('.shared-facts-additional-list' ,$toc).append('<li class="shared-facts-additional">'+hrefLink+'</li>')
    })
  }
}
